import { useContext } from 'react';
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  getMcvisID,
  getPageType,
  getSvocId,
  getItemId,
  getRecentSearchTerms
} from '../utils/assistant-context-utils';
import { getSessionId } from '../utils/session-utils';

/**
 * @returns {[
 *   ({ userQuestion: string, timestamp: number }) => void,
 *   { data: object, loading: boolean, error: string }
 * ]}
 */
export const useAssistantBot = () => {
  const {
    channel,
    deliveryZip,
    store
  } = useContext(ExperienceContext);

  const [submitToBot, response] = useLazyDataModel('retrieveDetails', {
    lazy: true
  });

  const submitUserQuestion = ({ userQuestion, timestamp }) => {
    // TODO: replace with useCustomer hook
    const sessionId = getSessionId();

    submitToBot({ variables: {
      userContext: {
        userIdentities: {
          mcvisId: getMcvisID(),
          svocId: getSvocId()
        },
        sessionId,
        storeId: store.storeId,
        zipCode: deliveryZip,
        deviceType: channel,
        language: 'en-US'
      },
      pageContext: {
        pageType: getPageType(),
        referrerPage: window.document.referrer,
        timestamp
      },
      questionContext: {
        itemId: getItemId(),
        userQuestion,
        recentSearchTerms: getRecentSearchTerms()
      },
      suggestedQuestions: true,
      followUpQuestions: false,
      model_name: 'pro002'
    } });
  };

  return [
    submitUserQuestion,
    response,
  ];
};
